( function( $ ) {
	'use strict';

	$( function() {
        const $trigger = $( '.js-tab-group-trigger' );
        const $target = $( '.js-tab-group-target' );
		const activeClass = 'is-active';

        $trigger.on( 'click', function() {
            // return if the clicked trigger is already active
            if ( $( this ).hasClass( activeClass ) ) {
                return;
            }

            // remove active class and set aria-expanded to false for all triggers
            $trigger.each( function() {
                $( this ).removeClass( activeClass );
                $( this ).attr( 'aria-expanded', false );
            } );

            // add active class and set aria-expanded to true for clicked trigger
            $( this ).addClass( activeClass );
            $( this ).attr( 'aria-expanded', true );

            // remove active class for all targets
            $target.each( function() {
                $( this ).removeClass( activeClass );
            } );

            // add active class to target based on aria-controls
            const targetId = $( this ).attr( 'aria-controls' );
            $( `#${targetId}` ).addClass( activeClass );
        } );
	} );
} )( jQuery );
